import React from "react";

const Popups = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 4h13a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-2v3.1a1 1 0 0 1-1.6.8L11.7 15H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Zm1 2v7h4a1 1 0 0 1 .6.2l3.4 2.55V14a1 1 0 0 1 1-1h1V6H8Z"
            fill="currentColor"
        />
        <path
            d="M4 8a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h1v2.1a1 1 0 0 0 1.6.8l1.9-1.4a1 1 0 0 0-1.2-1.6L6 19v-1a1 1 0 0 0-1-1v-8Z"
            fill="currentColor"
        />
    </svg>
);

export default Popups;
